import {atom} from "recoil"

const tenantAtom = atom({
  key: "tenantAtom",
  default: CurrentTenant.current()
})

export {tenantAtom}
